import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2, MessageSquare } from "lucide-react";

export const UnsoldLeadsCard = () => {
  const [mlo, setMlo] = useState("");
  const [days, setDays] = useState(7);
  const [mlos, setMlos] = useState([]);
  useEffect(() => {
    api.get("/admin/settings").then((r) => { setMlo(r.data.marketplace_unsold_mlo || ""); setDays(r.data.marketplace_listing_days || 7); }).catch(() => {});
    api.get("/admin/users").then((r) => setMlos(r.data.filter((u) => u.role !== "admin" && u.account_status === "active"))).catch(() => {});
  }, []);
  const [sending, setSending] = useState(false);
  const textAll = async () => {
    setSending(true);
    try { const { data } = await api.post("/admin/marketplace/text-mlos"); toast.success(`Ava texted ${data.mlos} MLO${data.mlos === 1 ? "" : "s"} about ${data.leads} lead${data.leads === 1 ? "" : "s"}`); }
    catch (e) { toast.error(apiError(e)); }
    setSending(false);
  };
  const save = async () => {
    try { await api.put("/admin/settings", { marketplace_unsold_mlo: mlo, marketplace_listing_days: Math.max(1, Number(days) || 7) }); toast.success("Unsold-lead rule saved"); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <Card className="mb-5 p-6" data-testid="unsold-leads-card">
      <h3 className="font-semibold text-slate-900">Unsold leads</h3>
      <p className="mt-1 text-sm text-slate-500">Each new lead stays in the Marketplace for this many days. When texting is on, Ava texts every MLO with Marketplace access when a lead is listed and again on its last day. If nobody buys it, it goes free ($0) to the MLO below.</p>
      <div className="mt-4 flex flex-wrap items-end gap-3">
        <label className="text-xs font-medium text-slate-600">Days in Marketplace
          <Input type="number" min="1" value={days} onChange={(e) => setDays(e.target.value)} className="mt-1 w-28" data-testid="unsold-days-input" />
        </label>
        <label className="min-w-0 flex-1 text-xs font-medium text-slate-600">Then give it free to
          <select value={mlo} onChange={(e) => setMlo(e.target.value)} className="mt-1 h-9 w-full rounded-md border border-slate-200 px-2 text-sm" data-testid="unsold-mlo-select">
            <option value="">Nobody - leave it listed</option>
            {mlos.map((m) => <option key={m.id} value={m.id}>{`${m.first_name || ""} ${m.last_name || ""}`.trim() || m.email} · {m.email}</option>)}
          </select>
        </label>
        <Button onClick={save} data-testid="unsold-save-btn">Save</Button>
      </div>
      <div className="mt-5 flex flex-col gap-3 border-t border-slate-100 pt-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-slate-500" data-testid="daily-text-note">Ava also texts every MLO the available leads and how long each one has left at 9 AM Eastern, Monday to Saturday.</p>
        <Button variant="outline" onClick={textAll} disabled={sending} className="shrink-0" data-testid="text-mlos-btn">
          {sending ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <MessageSquare className="mr-1.5 h-4 w-4" />} Text all MLOs now
        </Button>
      </div>
    </Card>
  );
};
